export const IntroSteps = {
  SEGMENT_1: 'SEGMENT_1',
  SEGMENT_2: 'SEGMENT_2',
  SEGMENT_3: 'SEGMENT_3',
  SEGMENT_4: 'SEGMENT_4',
} as const;

export type IntroSteps = (typeof IntroSteps)[keyof typeof IntroSteps];
